export default "__VITE_ASSET__BWP$Z7Sm__"